require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconChevronRight.tsx
var IconChevronRight_exports = {};
__export(IconChevronRight_exports, {
  default: () => IconChevronRight_default
});
module.exports = __toCommonJS(IconChevronRight_exports);

// src/assets/monochrome/chevronRight.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgChevronRight = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.85276 14.2098C7.74099 14.3206 7.65226 14.4526 7.59171 14.5979C7.53117 14.7432 7.5 14.8991 7.5 15.0565C7.5 15.2139 7.53117 15.3698 7.59171 15.5151C7.65226 15.6605 7.74099 15.7924 7.85276 15.9032C8.0762 16.1254 8.37846 16.25 8.69351 16.25C9.00856 16.25 9.3108 16.1254 9.53424 15.9032L14.6025 10.8348C14.8247 10.6114 14.9493 10.3091 14.9493 9.99403C14.9493 9.67897 14.8247 9.37673 14.6025 9.15329L9.53424 4.09677C9.3108 3.87465 9.00856 3.75 8.69351 3.75C8.37846 3.75 8.0762 3.87465 7.85276 4.09677C7.63065 4.32021 7.50597 4.62249 7.50597 4.93755C7.50597 5.25261 7.63065 5.55485 7.85276 5.77829L12.0744 10L7.85276 14.2098Z", fill: "#818898" }) });
var chevronRight_default = SvgChevronRight;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconChevronRight.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconChevronRight = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(chevronRight_default, {}) });
};
IconChevronRight.displayName = "IconChevronRight";
var IconChevronRight_default = IconChevronRight;
